export const DEV = process.env.VUE_APP_DEV === "true";
export const STEAM = process.env.VUE_APP_STEAM === "true";
export const MAC = window.navigator.platform === "MacIntel";
